import React, { useEffect, useRef, useState } from "react";
import { useL } from "@/lib/useL";
import { useParams } from "react-router-dom";
import { Printer, Download } from "lucide-react";
import { MindmapSvg } from "@/components/MindmapSvg";
import { printSvg, downloadPng } from "@/components/MindmapButton";

const API = process.env.REACT_APP_BACKEND_URL;
const btn = "font-mono uppercase tracking-[0.14em] text-[11px] px-4 py-3 border border-[#002FA7] text-[#002FA7] hover:bg-[#002FA7] hover:text-white transition-colors flex items-center gap-2";

// Public read-only mind map shared by a teacher (link / QR code).
export default function PublicMindmap() {
  const L = useL();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const svgRef = useRef(null);
  useEffect(() => {
    fetch(`${API}/api/public/mindmap/${id}`).then((r) => (r.ok ? r.json() : false)).then(setData).catch(() => setData(false));
  }, [id]);
  if (data === false) return <div className="p-10" data-testid="public-mindmap-not-found">{L("Cette carte mentale n'est pas (ou plus) partagée.", "This mind map is not (or no longer) shared.")}</div>;
  if (!data) return null;
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10" data-testid="public-mindmap-page">
      <div className="font-mono uppercase tracking-[0.2em] text-[11px] text-[#002FA7] mb-2">SUX1 · Carte mentale</div>
      <h1 className="text-3xl font-black mb-6" style={{ fontFamily: "Outfit" }} data-testid="public-mindmap-title">{data.title}</h1>
      <div className="border border-border overflow-x-auto"><div className="min-w-[640px]"><MindmapSvg ref={svgRef} data={data.mindmap} /></div></div>
      <div className="flex flex-wrap items-center justify-between gap-3 mt-6">
        <div className="flex flex-wrap gap-2">
          <button type="button" className={btn} onClick={() => printSvg(svgRef.current)} data-testid="public-mindmap-print"><Printer className="w-3.5 h-3.5" /> Imprimer (PDF)</button>
          <button type="button" className={btn} onClick={() => downloadPng(svgRef.current)} data-testid="public-mindmap-download"><Download className="w-3.5 h-3.5" /> {L("Télécharger l'image", "Download the image")}</button>
        </div>
        <a href="/" className="text-sm text-[#002FA7] underline" data-testid="public-mindmap-cta">{L("Créer mes propres cartes mentales avec SUX1", "Create my own mind maps with SUX1")}</a>
      </div>
    </div>
  );
}
